import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useUpdateAuthorMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (data: Parameters<typeof Api.authors.updateAuthor>[1]) =>
      Api.authors.updateAuthor(project, data),
  });
}
